<template>
	<div class="home">
		<n-space id="controls">
			<n-button-group>
				<n-button circle @click="resetZoom">
					<template #icon>
						<n-icon><zoom-cancel-icon /></n-icon>
					</template>
				</n-button>
			</n-button-group>
		</n-space>
		<n-progress id="unityLoadingBar" v-if="percentage < 100" class="center" type="circle" :percentage="percentage" processing/>
		<VueUnity id="unity" :unity="unityContext"></VueUnity>
		<div class="centered-container">
			<div v-if="views[0].views.length === 0" class="fixed-row">
				<n-skeleton height="80px" width="100%"/>
			</div>
			<div v-else class="fixed-row">
				<n-badge  v-for="(view, i) in views[0].views" :key="i" :value="1" :show="view.isSelected" dot class="fixed-item no-select" >
					<n-button style="height: 80px;" @click="onClick(views[0].views, view)">{{ view.name }}</n-button>
				</n-badge>
			</div>
			<div v-if="views[1].views.length === 0" class="scrollable-grid">
				<n-skeleton height="200px" width="100%"/>
			</div>
			<div v-else class="scrollable-grid">
				<div  class="grid-container">
					<n-badge v-for="(view, i) in views[1].views" :key="i" :value="1" :show="view.isSelected" dot  class="item no-select" >
						<n-button style="height: 80px;" @click="onClick(views[1].views, view)">{{ view.name }}</n-button>
					</n-badge>
				</div>
			</div>
		</div>
	</div>
</template>

<style>
body, html {
	width: 100%;
	height: 100%;
	margin: 0;
	font-family: Arial, sans-serif;
	display: flex;
	align-items: flex-end;
	justify-content: center;
	background-color: #f5f5f5;
	overflow: hidden;
}

.home {
	position: relative;
	width: 100%;
	height: 100%;
}

#unityLoadingBar {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 1;
}

#controls {
	position: absolute;
	top: 32px;
	right: 32px;
	z-index: 1;
}

.centered-container {
	position: absolute;
	width: 384px;
	max-height: 384px;
	left: 50%;
	bottom: 0px;
	border: 1px solid #ccc;
	background-color: #fff;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
	border-radius: 24px 24px 0px 0px;
	transform: translate(-50%, 100%);
	transition: transform 0.3s ease-out;
	z-index: 2;
}

.fixed-row {
	display: flex;
	justify-content: space-between;
	padding: 24px;
	border-bottom: 1px solid #ccc;
}

.fixed-item-loading {
	width: 80px;
	height: 80px;
	display: flex;
}

.fixed-item {
	width: 80px;
	height: 80px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.scrollable-grid {
	height: 200px;
	overflow-y: auto;
	padding: 24px;
}

.grid-container {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 8px;
}

.item {
	height: 80px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.no-select {
	-webkit-user-select: none;  /* Chrome, Safari, Opera */
	-moz-user-select: none;     /* Firefox */
	-ms-user-select: none;      /* IE 10+ */
	user-select: none;          /* Standard syntax */
}
</style>

<script setup>
import { onMounted, ref, reactive } from 'vue'
import UnityWebgl from 'unity-webgl'
import VueUnity from 'unity-webgl/vue'
import { ZoomCancel as ZoomCancelIcon } from "@vicons/tabler"

const percentage = ref(0)
const unityContext = new UnityWebgl({
  "dataUrl": "https://holofair-uae.s3.me-central-1.amazonaws.com/builds/edesigner/0.1.7/Build/WebGL.data.unityweb",
  "frameworkUrl": "https://holofair-uae.s3.me-central-1.amazonaws.com/builds/edesigner/0.1.7/Build/WebGL.framework.js.unityweb",
  "loaderUrl": "https://holofair-uae.s3.me-central-1.amazonaws.com/builds/edesigner/0.1.7/Build/WebGL.loader.js",
  "codeUrl": "https://holofair-uae.s3.me-central-1.amazonaws.com/builds/edesigner/0.1.7/Build/WebGL.wasm.unityweb",
  "streamingAssetsUrl": "https://holofair-uae.s3.me-central-1.amazonaws.com/builds/edesigner/0.1.7/StreamingAssets",
  "companyName": "Outreal XR",
  "productName": "ElevatorDesigner",
  "productVersion": "0.1.7"
})

unityContext.on('beforeMount', (ctx) => {
		console.log('beforeMount', ctx)
	}).on('mounted', (ctx) => {
		console.log('mounted', ctx)
	}).on('beforeUnmount', (ctx) => {
		console.log('beforeUnmount', ctx)
	}).on('progress', (progress) => {
		percentage.value = parseFloat((progress*100).toFixed(1));
	}).on('device', () => alert('click device ......'))

const isDragging = ref(false)
const initialY = ref(0)
const currentY = ref(0)

const views = reactive([
	{
		"viewid": 0,
		"views": []
	},
	{
		"viewid": 1,
		"views": []
	}
]);

function resetZoom() {
	unityContext.send("Main Camera","SetFocusPoint");
}

function onClick(views, view) {
	for (var i = views.length - 1; i >= 0; i--) views[i].isSelected = false;
	view.isSelected = true;
	unityContext.send("CompositeViews","SelectView", view.instanceID);
}

onMounted(() => {
	window.handleUnityMessage = function(message) {
		try {
			message = JSON.parse(message);
			console.log("Received message from Unity:", message);
			if("viewid" in message) {
				views[message.viewid] = message
				container.style.transition = 'transform 0.3s ease-out';
				if(message.viewid === 0) container.style.transform = 'translate(-50%, 65%)'; 
				else if(message.viewid === 1) container.style.transform = 'translate(-50%, 0)';
			}
		} catch (e) {
			console.log("Received message from Unity:", message);
		}
	};

	window.handleUnitySceneLoaded = function(scene) {
		console.log("Received scene from Unity:", scene);
	}
	
	const container = document.querySelector('.centered-container');

	container.addEventListener('mousedown', (e) => {
		isDragging.value = true;
		currentY.value = e.clientY;
		container.style.transition = 'none';
	});

	window.addEventListener('mousemove', (e) => {
		if (isDragging.value) {
			let deltaY = e.clientY - currentY.value;
			let transformValue = getComputedStyle(container).transform;

			if (transformValue === 'none') {
				transformValue = `translate(-50%, ${deltaY}px)`;
			} else {
				let currentTranslateY = parseFloat(transformValue.split(',')[5].trim());
				let proposedTranslation = currentTranslateY + deltaY;
				if (proposedTranslation < initialY.value) proposedTranslation = initialY.value;

				transformValue = `translate(-50%, ${proposedTranslation}px)`;
			}
			
			container.style.transform = transformValue;
			currentY.value = e.clientY;
			window.getSelection().removeAllRanges();
		}
	});

	window.addEventListener('mouseup', () => {
		if (isDragging.value) {
			isDragging.value = false;
			container.style.transition = 'transform 0.3s ease-out';
			
			let transformValue = getComputedStyle(container).transform;
			let currentTranslateY = 0;

			if (transformValue !== 'none') {
				let matrixValues = transformValue.split('(')[1].split(')')[0].split(',').map(parseFloat);
				currentTranslateY = matrixValues.length === 6 ? matrixValues[5] : matrixValues[matrixValues.length - 2];
			}

			if (currentTranslateY > 150) container.style.transform = 'translate(-50%, 65%)';
			else container.style.transform = 'translate(-50%, 0)';
		}
	});
})
</script>
